import Vue from 'vue'
import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization

import './icons' // icon
import './permission' // permission control
import * as filters from './filters' // 全局过滤器
import './directive' // 自定义指令

// echarts
import ECharts from 'vue-echarts'

// 按需引用相关图表
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
// import 'echarts/lib/chart/radiusAxis'

import TitleIcon from '@/components/TitleIcon' // 标题图标

//打印
import Print from 'vue-print-nb'

// 时间格式
import moment from 'moment'
Vue.prototype.$moment = moment

//图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer,{
    defaultOptions: {
        zIndex: 9999
    }
})
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    /* 需要注册百度地图开发者来获取你的ak */
    ak: '4LWxH4z2mFpcjWLxmLhD7yOTlmmcCLyZ'
})

import * as socketApi from '@/api/iori/socket'

//拖拽 缩放
import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize)

Vue.prototype.socketApi = socketApi


Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
})

Vue.use(Print);

// 注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// 全局注册v-chart组件
Vue.component('v-chart', ECharts);
// 全局注册标题图标组件
Vue.component('title-icon', TitleIcon);

Vue.config.productionTip = false;

// 全局注册通知组件
import Notification from './components/Notification'
Vue.use(Notification)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
